import { render, staticRenderFns } from "./ChooseOrUploadVideo.vue?vue&type=template&id=c61adca4&"
import script from "./ChooseOrUploadVideo.vue?vue&type=script&lang=js&"
export * from "./ChooseOrUploadVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports